import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { TripApprovalsTypes } from '../actions/actions.types'

type TripApprovalsState = ApplicationState['tripApprovals']

function tripApprovalsReducer(state: TripApprovalsState = new ImmutableMap(), action: IAction): TripApprovalsState {
	switch (action.type) {
		case TripApprovalsTypes.GetTripApprovals.SUCCESS:
			return state.set(action.requestPayload.tripId, action.payload)
	}
	return state
}

export default tripApprovalsReducer
